import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import utc from 'dayjs/plugin/utc';
import { ROLES } from 'vio-constants';
import { calculateGeoLocation } from '../mapbox/lib';
dayjs.extend(utc);
dayjs.extend(relativeTime);
export function areAnyUsersSelected(selectedUsers) {
    if (selectedUsers.length > 0) {
        return true;
    }
    return false;
}
export function calculateAllUserRoles(memberships, consumerAPI) {
    const allUserRoles = {};
    for (let i = 0; i < memberships.length; i += 1) {
        const membership = memberships[i];
        let org;
        let userRoles;
        if (consumerAPI) {
            const { organization, roles } = membership;
            const { slug } = organization;
            org = slug;
            userRoles = roles;
        }
        else {
            ({
                org,
                roles: userRoles
            } = membership);
        }
        allUserRoles[org] = Object.assign({}, ROLES.DEFAULT_PERMISSIONS);
        for (let j = 0; j < userRoles.length; j += 1) {
            let authorizations;
            let sites;
            if (consumerAPI) {
                ({
                    permissions: authorizations,
                    locations: sites
                } = userRoles[j]);
            }
            else {
                ({
                    authorizations,
                    sites
                } = userRoles[j]);
            }
            for (let k = 0; k < authorizations.length; k += 1) {
                const authorization = authorizations[k];
                const { name } = authorization;
                const initialAuthValue = allUserRoles[org][name];
                if (typeof initialAuthValue === 'boolean') {
                    allUserRoles[org][name] = true;
                }
                else {
                    if (initialAuthValue !== null && sites && sites.length > 0) {
                        if (Array.isArray(initialAuthValue)) {
                            allUserRoles[org][name] = [...new Set(initialAuthValue.concat(sites))];
                        }
                        else {
                            allUserRoles[org][name] = sites;
                        }
                    }
                    else {
                        allUserRoles[org][name] = null;
                    }
                }
            }
        }
    }
    return allUserRoles;
}
export function getLastLogin(lastLogin) {
    if (lastLogin !== null && lastLogin !== 'None') {
        const utcTime = dayjs.utc(lastLogin).toDate();
        return dayjs(utcTime).local().fromNow();
    }
    return undefined;
}
export function getUserLocation() {
    const promise = new Promise((resolve, reject) => {
        navigator.geolocation.getCurrentPosition(location => {
            const geoLocation = calculateGeoLocation(location);
            resolve(geoLocation);
        }, error => {
            reject(error);
        });
    });
    promise.catch(e => new Error(e));
    return promise;
}
export function isMarketAssignable(authorizations) {
    for (let i = 0; i < authorizations.length; i += 1) {
        const { market_specific } = authorizations[i];
        if (market_specific) {
            return true;
        }
    }
    return false;
}
export function removeUsers(users, usersToRemove) {
    return users.filter(item => {
        return !usersToRemove.includes(item.email);
    });
}
